import { VcsProvider } from "types/generated";
import { providerHasCommitHashes } from "utils/vcs";

export const getCommitDigitsCount = (provider: VcsProvider) => {
  return provider === VcsProvider.Gitlab ? 8 : 7;
};

// What a commit reads as in the UI. A provider without commit hashes tracks a free-form name,
// so there are no digits to shorten: cutting one to hash length turns release_2026-08-11 into
// release.
export const getCommitLabel = (provider: VcsProvider, hash: string) =>
  providerHasCommitHashes(provider) ? hash.slice(0, getCommitDigitsCount(provider)) : hash;
